"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutTooltip = exports.DonutChart = void 0;
var react_1 = __importStar(require("react"));
var arc_functions_1 = require("./arc-functions");
var Normalizer_1 = require("./Normalizer");
var dom_1 = require("@floating-ui/dom");
var react_dom_1 = require("react-dom");
var layout_utils_1 = require("./layout-utils");
function DonutLabel(_a) {
    var _b;
    var label = _a.label, setup = _a.setup;
    var t = (0, react_1.useRef)(null);
    var offset = (_b = setup.textRadiusOffset) !== null && _b !== void 0 ? _b : setup.radius + setup.thickness * .8;
    var innerText = setup.thickness > 30;
    var pos = innerText ? (0, arc_functions_1.polarToCartesian)(setup.x, setup.y, setup.radius - setup.thickness / 2, label.deg) :
        (0, arc_functions_1.polarToCartesian)(setup.x, setup.y, offset, label.deg);
    var _c = (0, react_1.useState)(pos.x), x = _c[0], setX = _c[1];
    (0, react_1.useLayoutEffect)(function () {
        if (t.current)
            setX(pos.x - t.current.getComputedTextLength() / 2);
    }, [label.title, label.deg]);
    if (label.value <= 5)
        return null;
    var props = innerText ? { className: "inner-text-".concat(label.style) } : {};
    return react_1.default.createElement("text", __assign({ ref: t, x: x, y: pos.y + 5 }, props, { style: { pointerEvents: "none" } }), label.title);
}
function getItemArcPath(full, setup, startDeg, endDeg, radius, innerRadius) {
    if (!full) {
        var innerBegin = (0, arc_functions_1.polarToCartesian)(setup.x, setup.y, innerRadius, startDeg);
        var d = "".concat((0, arc_functions_1.outerArc)(setup.x, setup.y, startDeg, endDeg, radius), " L ").concat(innerBegin.x, " ").concat(innerBegin.y, " ").concat((0, arc_functions_1.innerArc)(setup.x, setup.y, startDeg, endDeg, innerRadius), "z");
    }
    else {
        var d = [
            "M", setup.x - radius, setup.y,
            "A 1 1", "0 1 1", setup.x + radius, setup.y,
            "A 1 1", "0 0 1", setup.x - radius, setup.y,
            "M", setup.x - innerRadius, setup.y,
            "A 1 1", "0 1 1", setup.x + innerRadius, setup.y,
            "A 1 1", "0 0 1", setup.x - innerRadius, setup.y
        ].join(" ");
    }
    return d;
}
function DonutPiece(_a) {
    var item = _a.item, setup = _a.setup, startDeg = _a.startDeg, endDeg = _a.endDeg, selected = _a.selected;
    var ratio = 20 + setup.normalizer.normalize(item.value);
    ratio = ratio / 100;
    var full = (setup.total - item.value) <= 0.009;
    var d = getItemArcPath(full, setup, startDeg, endDeg, setup.radius * (selected ? 1.05 : 1), setup.innerRadius * (selected ? 0.95 : 1));
    var d2 = getItemArcPath(full, setup, startDeg, endDeg, setup.radius * (selected ? 1.15 : 1), setup.innerRadius);
    var selectClass = selected ? 'piece-seleted' : '';
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { fillRule: "evenodd", "data-item": item.label, className: "donut-piece-".concat(item.style, " opacity-50"), d: d2, style: { pointerEvents: "none" } }),
        react_1.default.createElement("path", { fillRule: "evenodd", "data-item": item.label, className: "donut-piece-".concat(item.style, " ").concat(selectClass), d: d }));
}
function buildSetup(options) {
    return __assign(__assign({}, options), { x: options.width / 2, y: options.height / 2, innerRadius: options.radius - options.thickness, normalizer: new Normalizer_1.Normalizer("value", 80), total: options.data.reduce(function (c, i) { return c + i.value; }, 0) });
}
function pieceBuilder(setup, selected) {
    var deg = 0;
    return function (item) {
        var startDeg = deg;
        deg = deg + (item.value / setup.total * 360);
        return react_1.default.createElement(DonutPiece, { key: item.label, item: item, selected: selected == item.label, startDeg: startDeg, endDeg: deg, setup: setup });
    };
}
function labelBuilder(setup) {
    var deg = 0;
    return function (item) {
        var labelDeg = deg + (item.value / 2 / setup.total * 360);
        deg = deg + (item.value / setup.total * 360);
        var label = {
            style: item.style,
            deg: labelDeg,
            title: (item.value / setup.total * 100).toFixed() + "%",
            value: item.value / setup.total * 100
        };
        return react_1.default.createElement(DonutLabel, { key: item.label, label: label, setup: setup });
    };
}
function DonutChart(options) {
    var _a, _b;
    var setup = (0, react_1.useMemo)(function () { return buildSetup(options); }, [options]);
    var ref = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(null), item = _c[0], setItem = _c[1];
    var _d = (0, react_1.useState)(null), tooltipContent = _d[0], setTooltipContent = _d[1];
    var _e = (0, react_1.useState)(null), tooltipPoint = _e[0], setTooltipPoint = _e[1];
    function onMouseMove(e) {
        var element = e.target;
        if ('dataset' in element && element.dataset.item) {
            setTooltipPoint({ x: e.clientX, y: e.clientY });
            setItem(element.dataset.item);
            return;
        }
        setItem(null);
    }
    function onTouchMove(e) {
        var element = e.target;
        if ('dataset' in element && element.dataset.item) {
            setTooltipPoint({ x: e.touches[0].clientX, y: e.touches[0].clientY });
            setItem(element.dataset.item);
            return;
        }
        setItem(null);
    }
    (0, react_1.useEffect)(function () {
        if (!setup.createTooltip)
            return;
        if (!item) {
            setTooltipContent(null);
            return;
        }
        var dataItem = setup.data.find(function (i) { return i.label == item; });
        setTooltipContent(setup.createTooltip(dataItem, setup));
    }, [item]);
    var windowWidth = (0, layout_utils_1.useWindowWidth)();
    (0, react_1.useEffect)(function () {
        setItem(null);
        setTooltipContent(null);
    }, [windowWidth]);
    function onItemClick(i) {
        var node = ref.current.querySelector("path[data-item=\"".concat(i.label, "\"]"));
        var c = node.getBoundingClientRect();
        setTooltipPoint({ x: c.x + c.width / 2, y: c.y + c.height / 2 });
        setItem(i.label);
    }
    var tooltipContainer = options.tooltipContainer ? ((_a = document.querySelector(options.tooltipContainer)) !== null && _a !== void 0 ? _a : document.body) : document.body;
    return react_1.default.createElement("div", { className: "donut-chart " + ((_b = options.className) !== null && _b !== void 0 ? _b : '') },
        react_1.default.createElement("div", { className: "svg-chart", ref: ref },
            react_1.default.createElement("svg", { width: options.width, height: options.height, onMouseLeave: function () { return setItem(null); }, onMouseMove: onMouseMove, onTouchMove: onTouchMove },
                react_1.default.createElement("g", { className: "group-donut" }, setup.data.map(pieceBuilder(setup, item))),
                react_1.default.createElement("g", { className: "labels" }, setup.data.map(labelBuilder(setup))))),
        react_1.default.createElement(DonutLegend, { setup: setup, onClick: onItemClick, selectedItem: item }),
        (0, react_dom_1.createPortal)(react_1.default.createElement(DonutTooltip, { strategy: options.tooltipContainer ? 'fixed' : 'absolute', key: "tooltip", content: tooltipContent, x: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.x, y: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.y }), tooltipContainer));
}
exports.DonutChart = DonutChart;
function DonutLegend(_a) {
    var setup = _a.setup, selectedItem = _a.selectedItem, onClick = _a.onClick;
    return react_1.default.createElement("div", { className: 'chart-legend' }, setup.data.map(function (i) { return react_1.default.createElement("div", { key: i.label, onClick: function () { return onClick(i); }, className: "".concat(i.style, " ").concat(i.label == selectedItem ? 'selected' : '') }, i.label); }));
}
function DonutTooltip(_a) {
    var content = _a.content, x = _a.x, y = _a.y, strategy = _a.strategy, _b = _a.placement, placement = _b === void 0 ? 'top' : _b;
    var toolTipRef = (0, react_1.useRef)(null);
    var ct = (0, react_1.useRef)();
    function buildVirtualElement() {
        return {
            getBoundingClientRect: function () {
                return {
                    width: 10,
                    height: 60,
                    x: x - 5,
                    y: y - 30,
                    top: y - 30,
                    left: x - 5,
                    right: x + 5,
                    bottom: y + 30,
                };
            }
        };
    }
    (0, react_1.useEffect)(function () {
        ct.current = content;
        if (!toolTipRef.current)
            return;
        if (content == null) {
            toolTipRef.current.style.visibility = 'hidden';
            return;
        }
        toolTipRef.current.style.display = "inline-block";
        (0, dom_1.computePosition)(buildVirtualElement(), toolTipRef.current, {
            strategy: strategy,
            placement: placement,
            middleware: [(0, dom_1.flip)(), (0, dom_1.shift)({ limiter: (0, dom_1.limitShift)({ offset: 10 }), padding: 30 })]
        }).then(function (_a) {
            var x = _a.x, y = _a.y;
            if (toolTipRef.current == null || content == null)
                return;
            Object.assign(toolTipRef.current.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                opacity: 1,
                visibility: 'visible'
            });
        });
    }, [toolTipRef.current, x, y, content]);
    return react_1.default.createElement("span", { ref: toolTipRef, className: 'chart-tooltip donut-tooltip', style: { opacity: !ct.current || !content ? 0 : 1, visibility: "hidden", display: "none" } }, content || ct.current);
}
exports.DonutTooltip = DonutTooltip;
//# sourceMappingURL=DonutChart.js.map